<template>
  <section class="app-ecommerce-details">
    <b-spinner v-if="isLoading" label="Récupération en cours"/>

    <div v-else>
      <!-- Alert: No item found -->
      <b-alert :show="currProduct === undefined" variant="danger">
        <h4 class="alert-heading">
          Erreur de récupération des données du produit
        </h4>
        <div class="alert-body">
          Aucun produit trouvé avec cette valeur. Vérifier
          <b-link class="alert-link" @click="$router.back()"> le magasin</b-link>
          pour d'autres produits.
        </div>
      </b-alert>

      <!-- Content -->
      <b-card v-if="currProduct" no-body>
        <b-card-body>
          <b-row class="my-2">
            <!-- Left: Product Image Container -->
            <b-col
                class="d-flex align-items-center justify-content-center mb-2 mb-md-0"
                cols="12"
                md="5"
            >
              <div class="d-flex align-items-center justify-content-center">
                <b-img
                    :alt="`Image de ${currProduct.uid}`"
                    :src="currProduct.image"
                    class="product-img"
                    fluid
                />
              </div>
            </b-col>

            <!-- Right: Product Details -->
            <b-col cols="12" md="7">
              <div class="d-flex justify-content-start mb-2">
                <b-button
                    class="btn-icon mr-1"
                    size="sm"
                    variant="primary"
                    @click="
                  goBack
                "
                >
                  <feather-icon icon="ArrowLeftIcon"/>
                </b-button>
                <!-- Product Name -->
                <h3>{{ currProduct.name }}</h3>
              </div>

              <!-- Product Brand -->
              <b-card-text class="item-company mb-0">
                <span>par</span>
                <b-link class="company-name">
                  {{ currProduct.brand.name }}
                </b-link>
              </b-card-text>

              <!-- Price And Ratings -->
              <div class="ecommerce-details-price d-flex flex-wrap mt-1">
              </div>

              <!-- Avability -->
              <b-card-text
              >Disponibilité -
                <span
                    :class="[
                  productAvailableInStock(currProduct)
                    ? 'text-success'
                    : 'text-danger',
                ]"
                >{{
                    productAvailableInStock(currProduct) ? "En stock" : "Vide"
                  }}</span
                ></b-card-text
              >

              <!-- Product Meta [Free shpping, EMI, etc.] -->
              <ul class="product-features list-unstyled">
                <li v-if="!currProduct.is_depreciable">
                  <feather-icon class="text-danger" icon="AlertTriangleIcon"/>
                  <span>Est consommable</span>
                </li>
                <li>
                  <feather-icon icon="TagIcon"/>
                  <span>Disponible : {{ currProduct.details.available }}</span>
                </li>
              </ul>

              <hr/>
              <!-- Product Description -->
              <i v-if="!currProduct.description" class="text-muted"
              >Aucune description sur cet article.</i
              >
              <b-card-text v-else>{{ currProduct.description }}</b-card-text>

              <hr/>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </section>
</template>

<script>
import store from "@/store";
import {computed, ref} from "@vue/composition-api";
import {BAlert, BButton, BCard, BCardBody, BCardText, BCol, BImg, BLink, BRow, BSpinner,} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import router from "@/router";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {useToast} from "vue-toastification/composition";

export default {
  directives: {
    Ripple,
  },
  components: {
    BSpinner,
    // BSV
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BAlert,
  },
  setup() {
    const toast = useToast();

    const isLoading = ref(false);
    const productAvailableInStock = (product) => {
      if (product.details === undefined) return false;
      return product.details?.available !== 0;
    };

    const showToast = (title, icon, variant) => {
      toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: icon,
          variant: variant,
        },
      });
    };

    const currProduct = computed(() => store.getters["stock/product"]);

    const goBack = () => {
      router.push({
        name: 'apps-stock-store-details',
        params: {id: currProduct.value.details.store},
      })
      store.commit("storeManagement/SET_CURRENT_PRODUCT", null)
    };

    const fetchProduct = () => {
      // Get product slug, stock & store
      const {id, stock_id, product_id} = router.currentRoute.params;

      store
          .dispatch("stock/fetchItem", {
            uid: product_id,
            stock: stock_id,
            store: id,
          })
          .catch((error) => {
            showToast("Une erreur est survenue lors du chargement du produit sélectionné.", "AlertCircleIcon", "danger");
          });
    };

    fetchProduct();

    return {
      isLoading,
      currProduct,
      productAvailableInStock,
      goBack,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce-details.scss";
</style>
